module.exports = "https://static.energy5.com/_next/static/images/slide01-b50fd606da688be4936d2047cd623405.webp";